// ================= FAQ_LIST =================== //

export const FAQ_LIST = "FAQ_LIST";
export const FAQ_LIST_SUCCESS = "FAQ_LIST_SUCCESS";
export const FAQ_LIST_FAIL = "FAQ_LIST_FAIL";

// ================= ADD_FAQ =================== //

export const ADD_FAQ = "ADD_FAQ";
export const ADD_FAQ_SUCCESS = "ADD_FAQ_SUCCESS";
export const ADD_FAQ_FAIL = "ADD_FAQ_FAIL";

// ================= FAQ_DETAILS =================== //
export const FAQ_DETAILS = "FAQ_DETAILS";
export const FAQ_DETAILS_SUCCESS = "FAQ_DETAILS_SUCCESS";
export const FAQ_DETAILS_FAIL = "FAQ_DETAILS_FAIL";

// ================= EDIT_FAQ =================== //

export const EDIT_FAQ = "EDIT_FAQ";
export const EDIT_FAQ_SUCCESS = "EDIT_FAQ_SUCCESS";
export const EDIT_FAQ_FAIL = "EDIT_FAQ_FAIL";

// ================= DELETE_FAQ =================== //

export const DELETE_FAQ = "DELETE_FAQ";
export const DELETE_FAQ_SUCCESS = "DELETE_FAQ_SUCCESS";
export const DELETE_FAQ_FAIL = "DELETE_FAQ_FAIL";
